import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var FaceVeryHappyOutlineSVG = function FaceVeryHappyOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M16,2A14,14,0,1,1,2,16,14,14,0,0,1,16,2Zm0,2A12,12,0,1,0,28,16,12,12,0,0,0,16,4Zm6.08,13.43a1,1,0,0,1,1,1c0,3.07-3.39,6.13-7.08,6.13S8.92,21.5,8.92,18.43a1,1,0,0,1,1-1H22.08Zm-1.21,2H11.13l0,.14a5.57,5.57,0,0,0,4.6,3H16a5.55,5.55,0,0,0,4.82-3h0ZM12,11a2,2,0,1,1-2,2A2,2,0,0,1,12,11Zm8,0a2,2,0,1,1-2,2A2,2,0,0,1,20,11Z"
  }));
};
FaceVeryHappyOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(FaceVeryHappyOutlineSVG);